<div class="container">
  <div *ngIf="loadProducts" id="loadingPage"></div>
  <div class="row fam" *ngIf="!loadProducts">
    <div class=" fam-c" *ngFor="let product of products;let i=index">
      <product (OnPersonalize)="PersonalizeModal(i)" (OnAdd)="addElementToBasket(i)" [product]="product"></product>
    </div>
  </div>
</div>